const {
    setViewData
} = require('gui');

module.exports = function partyPresenter(partyType, partyDto) {
    const view = require('./partyPresenter.tpl.html');
    const c = {};

    c.activate = function(region) {
        view.activate(region);
        view.typeRegion.innerText = partyType;
        setViewData(view, partyDto);
    };

    c.deactivate = function() {
        view.deactivate();
    };

    return c;
};
